import {
    replaceInChain,
} from "@insite/client-framework/HandlerCreator";
import { API_URL_CURRENT_FRAGMENT } from "@insite/client-framework/Services/ApiService";
import { AddCartLinesApiParameter } from "@insite/client-framework/Services/CartService";
import { getCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { chain, DispatchBeginPlaceOrder, PopulateAddLineCollectionApiParameter } from "@insite/client-framework/Store/Pages/SavedOrderDetails/Handlers/PlaceOrder";
import { CartLineModel } from "@insite/client-framework/Types/ApiModels";

// XC Customization - Removing Cartlines properties.

type PlcadeOrderProps = Parameters<typeof DispatchBeginPlaceOrder>[0];

function CustomPopulateAddLineCollectionApiParameter(props: PlcadeOrderProps)  {
    const state = props.getState();
    const order = props.parameter.order ?? getCartState(state, state.pages.savedOrderDetails.cartId).value;
    if (!order) {
        throw new Error("PlaceOrder was called but there was no order");
    }

    const availableLines = order.cartLines!.filter((cartLine: CartLineModel) => cartLine.canAddToCart);
    const availableLinesCopy = structuredClone(availableLines);

    if(availableLinesCopy){
            for(let i = 0; i < availableLinesCopy.length; i++)
            {
                delete availableLinesCopy[i].properties["messages"];
                delete availableLinesCopy[i].properties["warehouses"];
            }       
        }

    props.apiParameter = {
        cartId: API_URL_CURRENT_FRAGMENT,
        cartLineCollection: {
            cartLines: availableLinesCopy,
        },
    } as AddCartLinesApiParameter;
}

replaceInChain(
    chain,
    PopulateAddLineCollectionApiParameter,
    CustomPopulateAddLineCollectionApiParameter
);